module.exports = __webpack_public_path__ + "static/img/gj.7be1d850.png";